import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import Handlebars from 'handlebars';
import Global from 'models/Global';
import Auth from 'models/Auth';
import FormViewMixin from 'views/FormViewMixin';
import joinTemplate from 'hbars!templates/join';
import Config from 'config';

Handlebars.registerPartial('join', joinTemplate);

var JoinView = Backbone.View.extend({
    events: {
        'click .join-button': 'joinClicked',
        'click .login-box-sign-up-with-email': 'showEmailPassword',
        'click .hide-why-dropdown': 'hideWhyDropDown',
        'click .switch-sign-up-login-link': 'switchSignUpLoginClicked',
        'click .sign-up-email-password-button': 'signUpWithEmailClicked',
        'click .sign-in-email-password-button': 'signinClicked',
        'click .known-user-signout': 'signOutClick',
        'click .forgot-password-link': 'forgotPasswordClicked',
        'keyup input': 'clickIfEnter'
    },

    initialize: function(options) {
        _.bindAll(this, 'joinEvent');
        options = options || {};
        this.auth = new Auth();
        this.model = this.model || Global.get('me');
        this.event = options.event || Global.get('event');
        this.verifiedUserEmail = Global.get('verifiedUserEmail');
        this.verificationExpired = Global.get('verificationExpired');
        this.listenTo(this.auth, 'change:isLoading', this.setLoading);
        this.listenTo(this.model, 'change:isLoading', this.setLoading);
        this.listenTo(this.model, 'join-error', this.joinError);
        this.initValidation({
            attrs: ['primaryEmail', 'password'],
            ignoreKeyUp: ['primaryEmail', 'password'],
            tracking: false
        });
        if (Global.get('me').get('isVerified')) {
            this.switchView = 'login';
        } else {
            this.switchView = 'signup';
        }


        if (this.model.isNew()) {
            Backbone.trigger('analytics:ViewSignUp');
        }
    },

    showLinkedinOAuth: function() {
        this.model.set('provider', 'linkedin');
        this.stopListening(Backbone, 'linkedin-connect-success');
        this.listenToOnce(Backbone, 'linkedin-connect-success', this.linkedinConnectSuccess);
        this.auth.connectWithLinkedin();
    },

    getParameterByName: function(name) {
        let urlParams;
        try {
            urlParams = decodeURIComponent(window.location.search);
        } catch (e) {
            urlParams = '';
        }
        const match = RegExp('[?&]' + name + '=([^&]*)').exec(urlParams);
        return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
    },

    linkedinConnectSuccess: function(data) {
        this.model.set(this.model.parse(this.model.parseDataFromLinkedin(data)));
        this.auth.signInV2(data);
    },

    signUpWithEmailClicked: function() {
        this.model.set('provider', 'bizzabo');
        this.model.set('primaryEmail', $('.sign-up-cls input[name="primaryEmail"]').val());
        var valid = this.model.isValid('password') && this.model.isValid('primaryEmail');
        if (!valid) {
            var loginErrorWrapper = this.$('.login-error-wrapper');
            var text = 'Wrong Email or password';
            loginErrorWrapper.text(text);
            loginErrorWrapper.addClass('appear');
            _.delay(function() {
                loginErrorWrapper.removeClass('appear');
            }, 3000);
            return;
        }
        this.auth.signUpEmailPassV2({
            email: this.$('input[name="primaryEmail"]').val(),
            secret: this.$('input[name="password"]').val(),
            groupId: this.event.get('groupId'),
            next: this.getParameterByName('next') || this.getParameterByName('redirectUrl') || this.event.getCommunityUrl(),
            error: (errorCode) => {
                if (errorCode === 400) {
                    return this.signinClicked();
                } else {
                    this.auth.trigger('sign-up-error', errorCode);
                }
            }
        });
    },

    signinClicked: function() {
        var thisView = this;
        this.model.set('primaryEmail', $('.sign-in-cls input[name="primaryEmail"]').val());
        var valid = this.model.isValid('password') && this.model.isValid('primaryEmail');
        if (!valid) {
            var loginErrorWrapper = this.$('.login-error-wrapper');
            var text = 'Wrong Email or password';
            loginErrorWrapper.text(text);
            loginErrorWrapper.addClass('appear');
            _.delay(function() {
                loginErrorWrapper.removeClass('appear');
            }, 3000);
            return;
        }

        this.auth.signInV2({
            email: this.$('input[name="primaryEmail"]').val(),
            secret: this.$('input[name="password"]').val(),
            groupId: this.event.get('groupId'),
            eventId: this.event.get('id'),
            next: this.getParameterByName('next'),
            success: () => {
                var me = this.model;

                var success = function(meModel) {
                    me.set('isLoading', false);
                    me.isJoined(thisView.event.get('id'), {error: error, success: finalSuccess});
                };
                var finalSuccess = function(resposne) {
                    me.set('isJoined', resposne.joined);
                    if (me.get('status') !== 'user') {
                        thisView.trigger('sign-up-needed');
                    } else {
                        thisView.joinEvent();
                    }
                };
                var error = function() {
                    me.set('isLoading', false);
                };

                me.set('isLoading', true);
                me.fetch({
                    success: success,
                    error: error
                });


            }
        });
    },

    fetchMeAndJoinEvent: function() {
        var thisView = this;
        var me = this.model;

        var success = function() {
            me.set('isLoading', false);
            thisView.joinEvent();
        };
        var error = function() {
            me.set('isLoading', false);
        };

        me.set('isLoading', true);
        me.fetch({
            success: success,
            error: error
        });
    },

    joinEvent: function() {
        this.model.join(this.event.id);
    },

    joinClicked: function() {
        if (this.model.isNew()) {
            this.showLinkedinOAuth();
        } else {
            this.model.set('joinedNow', true);
            this.joinEvent();
        }
    },

    joinError: function(errorCode) {
        if (this.event.get('privacy') !== 'public') {
            return this.trigger('private-community');
        }
    },

    showSignInSignUp: function() {
        this.$('.login-wrapper').toggleClass('hide', this.switchView !== 'login');
        this.$('.sign-up-wrapper').toggleClass('hide', this.switchView !== 'signup');
        this.$('.login-error-wrapper').empty();
        this.$('.standard-form-error').empty();
    },

    setLoading: function() {
        var loading = this.auth.get('isLoading') || this.model.get('isLoading');
        this.$('.auth-view-join-button').toggle(!loading);
    },

    render: function() {
        var html = joinTemplate({
            me: this.model.toJSON(),
            event: this.event.toJSON(),

        });
        this.$el.html(html);
        this.showSignInSignUp();
        return this;
    },

    showEmailPassword: function() {
        this.model.set('provider', 'bizzabo');
        this.$('.login-box-sign-up-with-email').addClass('hide');
        this.$('.sign-up-email-password').addClass('expand-box-open');
        Backbone.trigger('analytics:ViewEmailSignUp');
    },

    hideWhyDropDown: function() {
        this.$('.why-signed-up-with-linkedin').dropdown('hide');
    },

    switchSignUpLoginClicked: function() {
        if (this.switchView == 'signup'){
            this.switchView = 'login';
            Backbone.trigger('analytics:ViewLogin');
        } else if (this.switchView == 'login') {
            this.switchView = 'signup';
            Backbone.trigger('analytics:ViewSignUp');
        }
        this.showSignInSignUp();
    },

    signOutClick: async function() {
        await this.auth.signOut();
        this.signedOut();
    },

    forgotPasswordClicked: function() {
        const redirectUrl = this.getParameterByName('redirectUrl') || this.event.getCommunityUrl();
        const groupId = this.event.get('groupId') || 1;
        window.location = `${Config.organizerUrl}/account/reset-password?attendee=true&redirectUrl=${encodeURIComponent(redirectUrl)}&groupId=${groupId}`;
    },

    signedOut: function() {
        location.reload();
    },

    clickIfEnter: function(e) {
        if (e.keyCode == 13){
            if (this.switchView === 'login') {
                this.$('.sign-in-email-password-button')[0].click();
            } else {
                this.$('.sign-up-email-password-button')[0].click();
            }
        }
    }

});
_.extend(JoinView.prototype, FormViewMixin);

export default JoinView;


